import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import Grid from "@material-ui/core/Grid";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import { read } from "Helpers/LocalStorage";
import { changeOlguSearch } from "Stores/actions";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import PatternService from "Services/http/endpoints/pattern/PatternService";
import StatusHandler from "Helpers/StatusHandler";
import {DialogActions} from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from 'react-i18next';
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { GET_OLGU_AGAIN } from "Stores/actionTypes";
import * as Icons from "react-bootstrap-icons";

function SlidingEditDialog({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);
  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: row.Name,
      validation: {
        required: true,
      },
    },
    frame: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    sash: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    sashDoor: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    isMulion: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    molionKatibeh: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    molionFrame: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    profileKomaki: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    panel: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    zehvar1: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    zehvar2: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    zehvar3: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    interLock: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    conectorSash: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    zehvarBaran: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    brandFitting: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    glass: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    net: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    coverWater: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  };
  const handleDialog = () => setOpenDialog(!openDialog);
  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    setFormValid((prev) => ({ ...prev, [controlName]: true }));
    setChange(true);
  };
  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if(change) {
      const { name, frame, sash, panel, conectorSash,
        sashDoor, isMulion, molionKatibeh, molionFrame, profileKomaki,
        zehvar1, zehvar2, zehvar3, interLock, zehvarBaran, brandFitting,
        glass, net, coverWater
      } = controls;

      if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
      )
        if (row.Type === 2) {
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdTemplate: +row.Id,
            IdCoverWater: coverWater.value?.value,
            Type: +row.Type,
            Name: name.value,
            IdBrandFitting: brandFitting.value?.value,
            IdFrame: frame.value?.value,
            IdGlass: glass.value?.value,
            IdMolion: isMulion.value?.value,
            IdMolionFrame: molionFrame.value?.value,
            idMolionKatibeh: molionKatibeh.value?.value,
            IdNet: net.value?.value,
            IdPanel: panel.value?.value,
            IdProfileKomaki: profileKomaki.value?.value,
            IdSash: sash.value?.value,
            IdSashDoor: sashDoor.value?.value,
            IdZehvar1: zehvar1.value?.value,
            IdZehvar2: zehvar2.value?.value,
            IdZehvar3: zehvar3.value?.value,
            IdInterlock: interLock.value?.value,
            IdConectorSash: conectorSash.value?.value,
            IdZehvarBaran: zehvarBaran.value?.value,
          };
          try {
            const response = await PatternService.updateTemplateLolaee(data);
            let err = StatusHandler(response);
            if (!err.isFail) {
              showNotify({
                text: t('The_template_was_edited_successfully'),
                customClass: "success",
              });
            }
            dispatch({ type: GET_OLGU_AGAIN, data: true });
          } catch (err) {
      console.error('[catch error]', err)
    }
          handleDialog();
        } else if (R.isEmpty(formValid)) {
          handleDialog();
        } else {
          showNotify({
            text: t('invalidInformation'),
            customClass: "error",
          });
        }
    } else {
      handleDialog();
    }
    setLoading(false);
  };

  const setDefaults = (data) => {
    for (let item in data) {
      const selectItems = data[item].items.map((child) => {
        return {
          label: child.Name,
          value: child.Id,
        };
      });
      const selectedValue = selectItems.find(
        (child) => child.value === data[item].SelectId
      ) || { value: 0, label: "" };
      if (data[item].Namekey === "Frame") {
        setControls({ frame: { selectItems: selectItems } });
        setControls({ frame: { value: selectedValue } });
      }
      if (data[item].Namekey === "Sash") {
        setControls({ sash: { selectItems: selectItems } });
        setControls({ sash: { value: selectedValue } });
      }
      if (data[item].Namekey === "SashDoor") {
        setControls({ sashDoor: { selectItems: selectItems } });
        setControls({ sashDoor: { value: selectedValue } });
      }
      if (data[item].Namekey === "Molion") {
        setControls({ isMulion: { selectItems: selectItems } });
        setControls({ isMulion: { value: selectedValue } });
      }
      if (data[item].Namekey === "MolionKatibe") {
        setControls({ molionKatibeh: { selectItems: selectItems } });
        setControls({ molionKatibeh: { value: selectedValue } });
      }
      if (data[item].Namekey === "MolionFrame") {
        setControls({ molionFrame: { selectItems: selectItems } });
        setControls({ molionFrame: { value: selectedValue } });
      }
      if (data[item].Namekey === "InterLock") {
        setControls({ interLock: { selectItems: selectItems } });
        setControls({ interLock: { value: selectedValue } });
      }
      if (data[item].Namekey === "ConectorSash") {
        setControls({ conectorSash: { selectItems: selectItems } });
        setControls({ conectorSash: { value: selectedValue } });
      }
      if (data[item].Namekey === "ZehvarBaran") {
        setControls({ zehvarBaran: { selectItems: selectItems } });
        setControls({ zehvarBaran: { value: selectedValue } });
      }
      if (data[item].Namekey === "CoverWater") {
        setControls({ coverWater: { selectItems: selectItems } });
        setControls({ coverWater: { value: selectedValue } });
      }
      if (data[item].Namekey === "ProfileKomaki") {
        setControls({ profileKomaki: { selectItems: selectItems } });
        setControls({ profileKomaki: { value: selectedValue } });
      }
      if (data[item].Namekey === "Panel") {
        setControls({ panel: { selectItems: selectItems } });
        setControls({ panel: { value: selectedValue } });
      }
      if (data[item].Namekey === "Zehvar1") {
        setControls({ zehvar1: { selectItems: selectItems } });
        setControls({ zehvar1: { value: selectedValue } });
      }
      if (data[item].Namekey === "Zehvar2") {
        setControls({ zehvar2: { selectItems: selectItems } });
        setControls({ zehvar2: { value: selectedValue } });
      }
      if (data[item].Namekey === "Zehvar3") {
        setControls({ zehvar3: { selectItems: selectItems } });
        setControls({ zehvar3: { value: selectedValue } });
      }
      if (data[item].Namekey === "Fitting") {
        setControls({ brandFitting: { selectItems: selectItems } });
        setControls({ brandFitting: { value: selectedValue } });
      }
      if (data[item].Namekey === "Glass") {
        setControls({ glass: { selectItems: selectItems } });
        setControls({ glass: { value: selectedValue } });
      }
      if (data[item].Namekey === "Net") {
        setControls({ net: { selectItems: selectItems } });
        setControls({ net: { value: selectedValue } });
      }
    }
  }

  const onEnter = async () => {
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdTemplate: row.Id,
        Type: row.Type,
      };
      const response = await PatternService.getOlguForEdit(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value.Items;
        setDefaults(data);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (openDialog) {
      onClear();
    }
  }, [openDialog]);

  const onClear = () => {
    setFormValid({});
    setControls({ name: { value: row.Name } });
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={
          (row.IsG &&
          read("StypeU") !== "1") ||
          read("templateRules")?.accessUpdate === false
        }
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="lg"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              <Translator id="edit_pattern" />
            </p>
          </div>
          <DialogContent className="pb-5">
            {
              !loading ?
              <Grid container spacing={2}>
                {
                  Object.keys(controls).map((key, index) => {
                    return (
                      <>
                        {
                          controls[key].type === "text" &&
                          <Grid item xs={12} key={key + index}>
                            <Input
                              loading={loading}
                              setValue={setValue.bind(this)}
                              name={key}
                              validation={controls[key].validation}
                              label={<Translator id={key} />}
                              type="text"
                              value={controls[key].value}
                            />
                          </Grid>
                        }
                        {
                          controls[key].type === "select" &&
                            <Grid item md={4} sm={6} xs={12} key={key + index}>
                              <MuiAutoComplete
                                loading={loading}
                                options={controls[key].selectItems}
                                label={<Translator id={key} />}
                                value={controls[key].value}
                                // heightLimit={true}
                                id={key}
                                onChange={autoCompleteHandler}
                              />
                            </Grid>
                        }
                      </>
                    );
                  })
                }
              </Grid> : <MuiSkeleton xs={4} number={12} />
            }
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default SlidingEditDialog;